import { useUser } from "@/api/users"

export default function UserInfo() {
  const { user } = useUser()

  if (!user) return null

  return (
    <div className="text-sm">
      {user.firstName ? user.firstName : user.email}
    </div>
  )
}
